module.exports = __webpack_public_path__ + "media/application/images/svgs/search-a4d53ee45c4de46b834d088d44b13518.svg";